module.exports = __webpack_public_path__ + "static/logo-bain-capital-ventures-72997b519276af51f5104e35f5eb1696.png";